import React from 'react'
import { useTranslation } from 'react-i18next'
import { AlertTriangle } from 'lucide-react'
import { exportClientDiagnostics } from 'services/clientDiagnostics'

type UnexpectedErrorFallbackProps = {
  onRetry: () => void
  supportCode?: string
}

export function UnexpectedErrorFallback({ onRetry, supportCode }: UnexpectedErrorFallbackProps) {
  const { t } = useTranslation()

  return (
    <div className="flex min-h-[50vh] flex-col items-center justify-center p-8 text-center">
      <div
        className="mb-4 flex h-16 w-16 items-center justify-center rounded-full bg-destructive/12 ring-1 ring-destructive/25"
        aria-hidden
      >
        <AlertTriangle className="h-8 w-8 text-destructive" strokeWidth={2} />
      </div>
      <h3 className="mb-2 text-lg font-semibold text-foreground">{t('common.unexpectedError.title')}</h3>
      <p className="mb-4 text-muted-foreground">{t('common.unexpectedError.description')}</p>
      {supportCode ? (
        <div className="mb-4 rounded-lg border border-border bg-muted px-4 py-2 font-mono text-sm text-foreground">
          {t('common.unexpectedError.supportCode')}: {supportCode}
        </div>
      ) : null}
      <div className="flex flex-wrap items-center justify-center gap-3">
        <button
          type="button"
          onClick={onRetry}
          className="rounded-lg bg-primary px-4 py-2 text-primary-foreground transition-colors hover:bg-primary-hover"
        >
          {t('common.unexpectedError.reload')}
        </button>
        {window.electronAPI?.exportDiagnostics ? (
          <button
            type="button"
            onClick={() => void exportClientDiagnostics()}
            className="rounded-lg border border-border px-4 py-2 text-foreground transition-colors hover:bg-muted"
          >
            {t('common.unexpectedError.exportDiagnostics')}
          </button>
        ) : null}
      </div>
    </div>
  )
}
